/* eslint-disable @typescript-eslint/no-explicit-any */
import type { Client, RequestContext } from "../client";
import type { RouteArgs } from "../resolver";
import type { ProxyResource, NewProxyResource } from "../resources";
import { BasicRepository, type ListArgs } from "./basicRepository";
export type MachineProxyListArgs = ListArgs & RouteArgs & {
    partialName?: string;
};
export class ProxyRepository extends BasicRepository<ProxyResource, NewProxyResource, MachineProxyListArgs> {
    constructor(client: Client, requestContext: RequestContext) {
        super("Proxies", client, requestContext);
    }
}
